// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 10px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  padding: 0 10px;
  transition: 0.1s ease;
  width: auto;
  margin: 10px;
}
.action-button-delete:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-delete-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small-trashCan {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  transition: 0.1s ease;
  padding: 5px 15px;
}
.action-button-small-trashCan:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small-trashCan:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #A7A9AC;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-hide-dropdown {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border: none;
  background: #0669B3;
  background: #A7A9AC;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 100%;
}
.action-button-hide-dropdown:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-hide-dropdown:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-birthdate-reset {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  width: 200px;
}
.action-button-birthdate-reset:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-birthdate-reset:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-reason {
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  font-size: 0.9rem;
  height: 30px;
  padding: 0px 20px;
  margin: 0 10px;
  transition: 0.1s ease;
  white-space: nowrap;
}

.select-button-icon {
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ActionButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAWF;;AARA;ECTI,kBDUsB;ECWtB,2CAAA;EDTA,eAAA;EACA,YAAA;EACA,mBDQS;ECPT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAWJ;AATI;EACE,uBAAA;EACA,mBAAA;AAWN;AATI;EACE,YAAA;EACA,mBAAA;AAWN;;AAPA;EC/BI,kBDgCsB;ECXtB,2CAAA;EDaA,eAAA;EACA,YAAA;EACA,mBDdS;ECeT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDtBa;ACgCnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPA;ECpDI,kBDqDsB;EChCtB,2CAAA;EDkCA,eAAA;EACA,YAAA;EACA,mBDnCS;ECoCT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD3Ca;ACqDnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECzEE,kBD0EsB;ECrDtB,2CAAA;EDuDA,eAAA;EACA,YAAA;EACA,mBDxDS;ECyDT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDhEa;AC0EnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;EC9FE,kBD+FsB;EC1EtB,2CAAA;ED4EA,eAAA;EACA,YAAA;EACA,mBD7ES;EC8ET,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDrFa;AC+FnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECnHE,kBDoHsB;EC/FtB,2CAAA;EDiGA,eAAA;EACA,YAAA;EACA,mBD7GE;EC8GF,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD3Ga;ACqHnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECzIE,kBD0IsB;ECrHtB,2CAAA;EDuHA,eAAA;EACA,YAAA;EACA,mBDnIE;ECoIF,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDhIa;AC0InB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;EC9JE,kBD+JsB;EC1ItB,2CAAA;ED4IA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDhJS;ECiJT,YAAA;EACA,qBAAA;EACA,iBAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBDtJa;ACgKnB;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECpLE,kBDqLsB;EChKtB,2CAAA;EDkKA,eAAA;EACA,YAAA;EACA,mBDxKI;ECyKJ,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAUJ;AARI;EACE,uBAAA;EACA,mBD/KE;ACyLR;AARI;EACE,YAAA;EACA,mBAAA;AAUN;;AAPE;ECxME,kBDyMsB;ECpLtB,2CAAA;EDsLA,eAAA;EACA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,mBD1LS;EC2LT,mBDhMI;ECiMJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AASJ;AAPI;EACE,uBAAA;EACA,mBDpMa;AC6MnB;AAPI;EACE,aAAA;EACA,mBAAA;AASN;;AANE;EClOE,kBDmOsB;EC9MtB,2CAAA;EDgNA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBDrNS;ECsNT,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAQJ;AANI;EACE,uBAAA;EACA,mBD7Na;ACqOnB;AANI;EACE,aAAA;EACA,mBAAA;AAQN;;AAJE;EC5PE,kBD6PsB;EACtB,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBD5OS;EC6OT,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAOJ;;AALE;EACE,aAAA;EACA,mBAAA;AAQJ;;AALE;EACE;IACE,iBAAA;IACA,gBAAA;EAQJ;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.button-with-status-container {\n  display: flex\n}\n.status-on-button {\n  position: relative;\n  bottom: 10px;\n  right: 20px\n}\n\n.action-button-reg {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n\n.action-button-80 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 80px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n.action-button-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-150 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 150px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-200 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 200px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-delete {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    height: 30px;\n    padding: 0 10px;\n    transition: 0.1s ease;\n    width: auto;\n    margin: 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-delete-100 {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $red;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    width: 100px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-small-trashCan {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    transition: 0.1s ease;\n    padding: 5px 15px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-cancel {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    border: none;\n    background: $grey2;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $grey3;\n    }\n    &:disabled {\n      opacity: .5;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-hide-dropdown {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n\n    border: none;\n    background: $pearl-blue;\n    background: $grey2;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    margin: 0 10px;\n    width: 100%;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .51;\n      cursor: not-allowed;\n    }\n  };\n  .action-button-birthdate-reset {\n    @include borderRadius(3px);\n    @include shadow();\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    height: 30px;\n    transition: 0.1s ease;\n    padding: 0px 20px;\n    width: 200px;\n\n    &:hover {\n      transform: scale(1.015);\n      background: $pearl-blue-hover;\n    }\n    &:disabled {\n      opacity: .51;\n      cursor: not-allowed;\n    }\n  };\n\n  .action-button-reason {\n    @include borderRadius(3px);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    border: none;\n    background: $pearl-blue;\n    color: white;\n    font-size: 0.9rem;\n    height: 30px;\n    padding: 0px 20px;\n    margin: 0 10px;\n    transition: 0.1s ease;\n    white-space: nowrap;\n  };\n  .select-button-icon {\n    display: flex;\n    align-items: center;\n  }\n\n  @media only screen and (max-width: 1080px) {\n    .action-button-reason {\n      font-size: 0.7rem;\n      padding: 0px 8px;\n    }\n  }","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
